// removed by extract-text-webpack-plugin
module.exports = {"title":"gD9On5YYjL76dt0z91Mpf"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets/UserBoxStats/widget.scss
// module id = 1231
// module chunks = 0